import { render, staticRenderFns } from "./RoundChatAction.vue?vue&type=template&id=37a51bd8&"
import script from "./RoundChatAction.vue?vue&type=script&lang=js&"
export * from "./RoundChatAction.vue?vue&type=script&lang=js&"
import style0 from "./RoundChatAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports